import { atom } from 'jotai';

type HistoryItem = {
  path: string,
  params: string,
};

export const historyAtom = atom<HistoryItem[]>([]);
